export const addNotification = (
  message,
  notificationsContext,
  type = 'success'
) => notificationsContext.addNotification(message, type);
